import { normalizeString } from './accent';

export const STANDARD_FIELD_ADDRESS = 'address';
export const STANDARD_FIELD_ROAD = 'road';
export const STANDARD_FIELD_HOUSE_NUMBER = 'houseNumber';
export const STANDARD_FIELD_DISTRICT = 'district';
export const STANDARD_FIELD_ZIP = 'zip';
export const STANDARD_FIELD_CITY = 'city';
export const STANDARD_FIELD_STATE = 'state';
export const STANDARD_FIELD_CLIENT = 'client';
export const STANDARD_FIELD_CNPJ = 'cnpj';
export const STANDARD_FIELD_CPF = 'cpf';
export const STANDARD_FIELD_ORDER = 'order';
export const STANDARD_FIELD_TIME_FORECAST = 'timeForecast';
export const STANDARD_FIELD_TIME_RESTRICTION = 'timeRestriction';
export const STANDARD_FIELD_ESTIMATED_ONSITE_DURATION = 'estimatedOnsiteDuration';
export const STANDARD_FIELD_TIME_OFFSET_OF_NEXT_SERVICE = 'timeOffsetOfNextService';
export const STANDARD_FIELD_DELIVERY_WINDOW = 'deliveryWindow';
export const STANDARD_FIELD_NAME = 'name';
export const STANDARD_FIELD_LOAD = 'load';

const RAW_STANDARD_FIELDS = {
  [STANDARD_FIELD_ADDRESS]: ['end', 'endr', 'endereco', 'enderecos'],
  [STANDARD_FIELD_ROAD]: ['rua', 'ruas'],
  [STANDARD_FIELD_HOUSE_NUMBER]: ['num', 'numero', 'numeros'],
  [STANDARD_FIELD_DISTRICT]: ['bairro', 'bairros'],
  [STANDARD_FIELD_ZIP]: ['cep', 'ceps'],
  [STANDARD_FIELD_CITY]: ['cidade'],
  [STANDARD_FIELD_STATE]: ['estado', 'uf'],
  [STANDARD_FIELD_CLIENT]: ['cliente', 'clientes'],
  [STANDARD_FIELD_CNPJ]: ['cnpj', 'cnpjs'],
  [STANDARD_FIELD_CPF]: ['cpf', 'cpfs'],
  [STANDARD_FIELD_ORDER]: ['ordem', 'ordems'],
  [STANDARD_FIELD_TIME_FORECAST]: ['Previsão de horário'],
  [STANDARD_FIELD_TIME_RESTRICTION]: ['Restricao de Horário'],
  [STANDARD_FIELD_ESTIMATED_ONSITE_DURATION]: ['Duração estimada no local'],
  [STANDARD_FIELD_TIME_OFFSET_OF_NEXT_SERVICE]: ['Tempo de deslocamento até o próximo serviço'],
  [STANDARD_FIELD_DELIVERY_WINDOW]: ['Janela de entrega'],
  [STANDARD_FIELD_NAME]: ['nome'],
  [STANDARD_FIELD_LOAD]: ['Carga'],
};

export type SheetStandardKeys = keyof typeof RAW_STANDARD_FIELDS;

export type SheetStandardFields = Record<SheetStandardKeys, string[]>;

/**
 * This function will remove accents and lowercase from every possible value in the Sheet fields map
 * @method normalizeStandardFields
 * @param  rawStandardFields       A map with possible header values
 * @return                         The same map, with normalized values
 */
function normalizeStandardFields(rawStandardFields: SheetStandardFields): SheetStandardFields {
  const keys = Object.keys(rawStandardFields) as unknown as SheetStandardKeys[];
  return keys.reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: rawStandardFields[curr].map(normalizeString),
    }),
    {}
  ) as SheetStandardFields;
}

export const normalizedStandardFields: SheetStandardFields = normalizeStandardFields(RAW_STANDARD_FIELDS);

/**
 * This function searches normalizedStandardFields for a string. If it finds it, returns the key where it was found, otherwise, returns the original argument
 * @method normalizeFieldToStandardField
 * @param  {string} searchField          The string to search for
 * @return                               The normalizedStandardFields key or the original argument
 */
export function normalizeFieldToStandardField(searchField: string) {
  const entriesFromNormalizedStandardFields = Object.entries(normalizedStandardFields);

  for (const [standardField, variationFields] of entriesFromNormalizedStandardFields) {
    const matchStandardField = variationFields.includes(searchField);
    if (matchStandardField) {
      return standardField;
    }
  }

  return searchField;
}
